import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../Auth/_redux/authRedux";

const initialListingsState = {
  activeTab: 0,
};

export const configurationSlice = createSlice({
  name: "configurationSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    setConfigurationPageTabIndex: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setConfigurationPageTabIndex } = configurationSlice.actions;
